module.exports = __webpack_public_path__ + "static/media/page404animation.7e7763fe.gif";